import React, { useMemo } from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { getOfferDeadline, spotsTakenPercent } from '../utils/offer';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/** Bloque de urgencia que se sitúa justo encima de la tarjeta de precio. */
export function CountdownTimer() {
  const deadline = useMemo(() => getOfferDeadline(), []);
  const {
    days,
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown(deadline);
  const units = [{
    value: days,
    label: 'días'
  }, {
    value: hours,
    label: 'horas'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <div className="rounded-3xl border border-track/40 bg-track/10 px-5 py-6 text-center sm:px-7" data-id="element-29" data-mp="15f7ewl27j08u">
      <p className="flex items-center justify-center gap-2 font-sans text-[11px] font-semibold uppercase tracking-[0.18em] text-track" data-id="element-30" data-mp="34q8indivejyg">
        <AlarmClockIcon className="h-4 w-4" strokeWidth={2} aria-hidden="true" data-id="element-31" data-mp="1c0op0fy0njq7" />
        Precio de lanzamiento — termina en:
      </p>

      {isExpired ? <p className="mt-4 font-display text-xl font-bold leading-snug text-ivory" data-id="element-32" data-mp="1h0jdydy8dz8m">
          El precio de lanzamiento ha terminado.
        </p> : <>
          <div className="mt-5 grid grid-cols-4 gap-2 sm:gap-3" aria-hidden="true" data-id="element-33" data-mp="171lq7d8mq9qo">
            {units.map(unit => <div key={unit.label} className="rounded-2xl border border-line bg-ink px-2 py-3" data-id="element-34" data-mp="1urg6y5w2kig7">
                <span className="block font-display text-3xl font-bold leading-none text-ivory sm:text-4xl" data-id="element-35" data-mp="1zpzu29meg0a5">
                  {pad(unit.value)}
                </span>
                <span className="mt-1.5 block font-sans text-[10px] font-semibold uppercase tracking-[0.12em] text-stone" data-id="element-36" data-mp="1kzafqydn6522">
                  {unit.label}
                </span>
              </div>)}
          </div>
          <p className="sr-only" role="timer" data-id="element-37" data-mp="2do7j7vd71xar">
            Quedan {days} días, {hours} horas, {minutes} minutos y {seconds}{' '}
            segundos al precio de lanzamiento.
          </p>

          <div className="mt-6 border-t border-line pt-5" data-id="element-38" data-mp="2san0wwwk19mj">
            <div className="flex items-baseline justify-between gap-4 font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-stone" data-id="element-39" data-mp="2nepnozgl8jdz">
              <span data-id="element-40" data-mp="2jdvze4z8h2kk">Cupos de lanzamiento</span>
              <span className="text-track" data-id="element-41" data-mp="2ebwv8svo61mk">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-graphite" role="progressbar" aria-valuenow={spotsTakenPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos de lanzamiento tomados" data-id="element-42" data-mp="29eew1u7gf0rr">
              <div className="h-full rounded-full bg-track" style={{
            width: `${spotsTakenPercent}%`
          }} data-id="element-43" data-mp="1zp3nq9se604x" />
            </div>
            <p className="mt-2 text-right font-sans text-[11px] text-stone" data-id="element-44" data-mp="1vknj0buikyra">
              {spotsTakenPercent}% de cupos tomados
            </p>
          </div>
        </>}
    </div>;
}